import { NgModule } from '@angular/core';
import { ServiceWorkerModule } from '@angular/service-worker';
// import { ApmService } from '@elastic/apm-rum-angular';

import { environment } from 'src/environments/environment';

// Import containers
import { BaseLayoutHeaderComponent } from 'src/app/containers/shared/base-layout-header/base-layout-header.component';
import { BaseLayoutFooterComponent } from 'src/app/containers/shared/base-layout-footer/base-layout-footer.component';
import { EIgrejaLayoutComponent } from 'src/app/containers/eigreja-layout';

const APP_CONTAINERS = [
  BaseLayoutHeaderComponent,
  BaseLayoutFooterComponent,
  EIgrejaLayoutComponent
];

// Modules
import { CoreModule } from 'src/app/core/core.module';
import { EIgrejaRoutingModule } from './eigreja.routing';

import { AppComponent } from '../shared/app.component';
import { TaskStatusNotificationComponent } from 'src/app/modules/core/task-status/task-status-notification/task-status-notification.component';
import { SupportButtonComponent } from 'src/app/shared/components/support-button/support-button.component';

const APP_MODULES = [
  CoreModule,
];

@NgModule({
  imports: [
    EIgrejaRoutingModule,
    ...APP_MODULES,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
  ],
  declarations: [
    AppComponent,
    TaskStatusNotificationComponent,
    SupportButtonComponent,
    ...APP_CONTAINERS,
  ],
  providers: [
    // ApmService
  ],
  bootstrap: [AppComponent]
})
export class EIgrejaModule {
  constructor(
    // apmService: ApmService,
  ) {
    // Agent API is exposed through this apm instance
    // const apm = apmService.init({
    //   serviceName: 'eigreja',
    //   serverUrl: 'https://56dc5ee1bcad47068a2be4b2bdc25340.apm.us-central1.gcp.cloud.es.io:443',
    //   environment: environment.production ? 'production' : 'development'
    // });
  }
}
